// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__3WYza","item":"Legend_item__1XG4R","indicator":"Legend_indicator__sHu5k"};